import ShortUniqueId from 'short-unique-id'
import { makePass } from '/providers/passes-api'
import _ from 'lodash'

import config from '/providers/config.json'

const batchSendMakePasses = async ({
  apiKey,
  apiSource,
  apiMode,
  templateId,
  dataSource,
  passData,
  variables,
  setMakePassResults,
  setPassesToProcess,
  batchSize = 10,
  onProgress,
}) => {
  try {

    let response = { ok: true }

    let data = dataSource === "upload" ? passData : [_.cloneDeep(variables)]

    // Add check here to see if we have enough capacity before we start...

    if (apiMode === "test") data = data.slice(0, config.maxTestPasses)

    if (dataSource === "sample") {
      data.map((d, i) => {
        _.set(d,"pass.pass_id",shortUUID())
        return d
      })
    }

    let results = []
    let processedCount = 0

    setPassesToProcess(data.length)
    if (onProgress) onProgress({ total: data.length, processed: 0, remaining: data.length, failed: 0, succeeded: 0 })

    for (let d = 0; d < data.length; d += batchSize) {
      const chunk = data.slice(d, d + batchSize)
      const chunkResults = await Promise.all(chunk.map(item =>
        sendMakePass({ apiKey, apiSource, apiMode, templateId, passId: item.pass.pass_id, variables: item })
      ))

      chunkResults.forEach(r => {
        if (!r.ok || r.error) {
          response = r
          results = [...results, {
            id: r.passId,
            error: r.error?.message ?? r.error
          }]
        } else {
          results = [...results, {
            id: r.pass_id,
            appleUrl: r.appleUrl,
            googleUrl: r.googleUrl,
          }]
        }
      })

      processedCount += chunk.length
      setMakePassResults(results)
      if (onProgress) {
        const failed = results.filter(r => r.error).length
        const succeeded = results.length - failed
        onProgress({
          total: data.length,
          processed: processedCount,
          remaining: Math.max(0, data.length - processedCount),
          failed,
          succeeded
        })
      }
    }

    return response
  }
  catch (err) {
    console.error(err)
  }
}

export default batchSendMakePasses


const sendMakePass = async ({ apiKey, apiSource, apiMode, templateId, passId, variables }) => {
  const result = await makePass({ apiKey, apiSource, apiMode, templateId, passId, variables})

  return { ...result, passId }
}

const shortUuidDictionary = [
  '0', '1', '2', '3',
  '4', '5', '6', '7',
  '8', '9', 'A', 'B',
  'C', 'D', 'E', 'F',
  'G', 'H', 'J', 'K',
  'L', 'M', 'N', 'P', 'Q',
  'R', 'T', 'U', 'V', 'W',
  'X', 'Y'
]

function shortUUID() {
  const uid = new ShortUniqueId({ length: 12, dictionary: shortUuidDictionary })
  const uuid = uid.rnd()

  const uuidArray = uuid.match(/.{1,4}/g)
  const formattedUUID = uuidArray.join("-")

  return formattedUUID
}
